const env = 'production' || 'production';
const config = require('./config.json')[env];

module.exports = {config};